<template>
  <div>
    <Pane />

    <div class="container">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" :colon="false" @submit="handleSubmit" :form="form">
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="制度文档名称">
              <a-input v-decorator="[
                'adminName',
                { rules: [{ required: true, message: '请输入！' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="发文部门">
              <a-select
                v-decorator="[
                    'department',
                ]"
                show-search
                :filter-option="$selectFilterOption"
              >
                <a-select-option
                  v-for="item in productionDepartmentList"
                  :key="item.id"
                  :value="item.uniqueName"
                >
                  {{
                  item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="发布日期">
            <a-date-picker placeholder="" v-decorator="['issueDate']" style="width: 100%" />
            </a-form-item>
          </a-col>  
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="实施日期">
            <a-date-picker placeholder="" v-decorator="['implementationDate']" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="废止日期">
            <a-date-picker placeholder="" v-decorator="['abolishDate']" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="制度状态">
              <a-select style="width: 100%" v-decorator="['statusStd',{ rules: [{ required: true, message: '请输入！' }] }]">
                  <a-select-option v-for="item in statusStdList" :key="item.value" :value="item.value">{{ item.name
                  }}</a-select-option>
                </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item label="制度文档附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
              <Upload :list="attachmentList" @change="uploaded" />

              <Padding />

              <a-table bordered :data-source="attachmentList" :pagination="false">
                <a-table-column title="文件名">
                  <template slot-scope="text">
                    <a :href="text.completePath" target="_blank">{{
                      text.name
                    }}</a>
                  </template>
                </a-table-column>
                <a-table-column title="操作" align="center">
                  <template slot-scope="text, record, index">
                    <a href="#" class="danger" @click.prevent="remove(index)">删除</a>
                  </template>
                </a-table-column>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">保存</a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import organization from "@/mixins/organization";
import { mapGetters } from "vuex";
import Upload from "./components/upload";
import request from "@/api/request";

function add(data) {
  return request({
    url: "/ai-service/kbdocument/admin/add",
    method: "post",
    data
  });
}
export default {
  mixins: [ organization],  
  components: {
    Upload,
  },

  data() {
    return {
      form: this.$form.createForm(this),
      attachmentList: [],
      formData: '',
      category: {},
      categoryList: [],
      activeCategoryIndex: 0,

      achievementVisible: false,
      editingAchievement: {},
      editingAchievementIndex: -1,
      achievementList: [], // 科研成果

      loading: false,
    };
  },

  computed: {

    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("kb_doc_dict.kb_doc_standard_types");
    },
    statusStdList() {
      return this.findDataDict("kb_doc_dict.kb_doc_status");
    },
  },


  methods: {
    addAchievement() {
      this.editingAchievement = {};
      this.editingAchievementIndex = -1;
      this.achievementVisible = true;
    },
    editAchievement(text, index) {
      this.editingAchievement = text;
      this.editingAchievementIndex = index;
      this.achievementVisible = true;
    },
    removeAchievement(index) {
      this.achievementList.splice(index, 1);
    },

    uploaded(file, fileName) {
      this.formData = file;
      this.attachmentList = []
      this.attachmentList.push({
        name: fileName,
      });
    },
    remove(index) {
      this.attachmentList.splice(index, 1);
      this.file = null;
    },

    handleSubmit(e) {
      e.preventDefault();
      if(this.attachmentList.length < 1){
        this.$message.error("请上传制度文档附件！");
        return;
      }  
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          const json = {
            ...values,
          }
          this.formData.append('req', new Blob([JSON.stringify(json)],{ type: 'application/json'}))
          add(this.formData)
            .then(() => {
              this.$close(this.$route.path);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 30px 164px;
}

.center {
  margin-top: 91px;
}
</style>
